<template>
    <div>
        <loading-progress-bar v-if="loading" :loading="loading" color="secondary"></loading-progress-bar>
        <v-layout row wrap v-if="!loading">
            <v-flex xs12  v-if="data&&!ecMode" :class="[hideKpi ? 'md12' : 'md10']">
                <vue-plotly :white-mode="whiteMode" show-export :data="data" :layout="layout" :options="{}" ref="plotly"/>
            </v-flex>
            <v-flex xs12 v-if="ecMode&&ecConfig" :class="[hideKpi ? 'md12' : 'md10']">
                <vue-echart :white-mode="whiteMode" :config="ecConfig" :height="490"></vue-echart>
            </v-flex>
            <v-flex xs12 md2 v-if="data&&!hideKpi">
                <v-layout row wrap>
                    <v-flex xs12 v-if="preCOP&&showMeanCop">
                        <value-box :white-mode="whiteMode" :value="preCOP" unit="" :title="'BMS COP'|translate"></value-box>
                    </v-flex>
                    <v-flex xs12 v-if="postCOP&&showMeanCop">
                        <value-box :white-mode="whiteMode" :value="postCOP" unit="" :title="'Optimized COP'|translate"></value-box>
                    </v-flex>
<!--                    <v-flex xs12 v-if="COPImpr">-->
<!--                        <value-box :value="COPImpr" unit="%" title="COP Improvement"></value-box>-->
<!--                    </v-flex>-->
                    <v-flex xs12 v-if="totalSavingSum">
                        <value-box :white-mode="whiteMode" :value="savingPercentage" unit="%" :title="'Energy Savings'|translate"></value-box>
                    </v-flex>
                    <v-flex xs12 v-if="totalSavingSum">
                        <value-box :white-mode="whiteMode" :value="totalSavingSum" unit="kWh" :title="'Energy Savings'|translate" has-comma></value-box>
                    </v-flex>
                    <v-flex xs12 v-if="ecMode">
                        <v-switch color="success"  :label="'Monthly Savings'|translate" v-model="ecMonthly" v-if="ecConfig3"></v-switch>
                        <v-btn v-if="ecMonthly" class="primary mx-2" @click="exportMonthly"><v-icon left small>fa-download</v-icon>Download</v-btn>
                        <v-switch color="success"  :label="'Summary'|translate" v-model="ecSummary"></v-switch>
                    </v-flex>
                    <v-flex xs12 v-if="showCopyBtn&&loessData">
                        <v-btn color="primary" @click="copyToCP">Copy interpolation data</v-btn>
                    </v-flex>

                </v-layout>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    import {callAPI,findLineByLeastSquares} from '@/helper'
    import LoadingProgressBar from './../LoadingProgressBar'
    import VuePlotly from "./../VuePlotly";
    import moment from 'moment'
    import ValueBox from "./../ValueBox";
    import VueEchart from "@/components/VueEchart";
    import data3Processor from "../mixins/data3Processor";
    import smoothLine from "../mixins/smoothLine";
    import {exportCSV} from "../../tocsv";
    export default {
        props: {
            customInterpolation:{type: String, default: null},
            customPostInterpolation:{type: String, default: null},
            postInterpolationPoints:{type: String, default: null},
            parameters: {type: Object, default: null},
            span: {type: Number, default: 0.6},
            band: {type: Number, default: 0.8},
            degree: {type: Number, default: 1},
            interpolation:{type: String, default: "linear"},
            postInterpolation:{type: String, default: null},
            resamplingFactor:{type: Number, default: null},
            powerSensor:{type: String, default: "Power"},
            coolingLoadSensor:{type: String, default: "Cooling_Load"},
            title:{type: String, default: "COP Improvement"},
            startDate:{type: String, default: null},
            endDate:{type: String, default: null},
            cutOff:{type: String, default: null},
            useSwitch:{type: Boolean, default: false},
            showCopyBtn:{type: Boolean, default: false},
            switchSensor:{type: String, default: "Header - Switch_Optimization"},
            dateRange: {type: Object, default: null},
            showMeanCop: {type: Boolean, default: true},
            showNegativeMonthly: {type: Boolean, default: false},
            hideKpi: {type: Boolean, default: false},
            whiteMode:{type:Boolean, default: false},
            ecMode:{type:Boolean, default: false},
            data3query: {
                type: Object, default: function () {
                    return {
                        "layout-overrides": {
                            "title": "",
                            "showlegend": false,
                            "height": 300,
                            "margin": {
                                "l": 50,
                                "r": 50,
                                "b": 0,
                                "t": 0,
                                "pad": 1
                            },
                            "xaxis": {
                                "title": ""
                            },
                            "yaxis": {
                                "title": ""
                            },
                            "zaxis": {
                                "title": null
                            }
                        },
                        "x-axis": "timestamp",
                        "y-axis": null,
                        "independent-x": false,
                        "color-axis": null,
                        "marker-size-axis": null,
                        "color-axis-scale": null,
                        "color-axis-title": null,
                        "data-payload": [
                            {
                                "filters": {
                                    "sensor_name": "Power"
                                },
                                "seriesOverrides": {
                                    "type": "table",
                                    "opacity": 1,
                                    "xbins": {
                                        "size": 1
                                    },
                                    "ybins": {
                                        "size": 1
                                    }
                                },
                                "pipeline": [
                                    {
                                        "type": "agg_h",
                                        "agg_op": "sum",
                                        "name": "Power"
                                    }
                                ],
                                "offsetRange": false,
                                "offsetType": "months",
                                "offsetAmount": 1
                            },{
                                "filters": {
                                    "sensor_name": "Cooling_Load"
                                },
                                "seriesOverrides": {
                                    "type": "table",
                                    "opacity": 1,
                                    "xbins": {
                                        "size": 1
                                    },
                                    "ybins": {
                                        "size": 1
                                    }
                                },
                                "pipeline": [
                                    {
                                        "type": "agg_h",
                                        "agg_op": "sum",
                                        "name": "Cooling_Load"
                                    }
                                ],
                                "offsetRange": false,
                                "offsetType": "months",
                                "offsetAmount": 1
                            },

                        ]
                    }
                }
            },
        },
        components: {LoadingProgressBar,VuePlotly,ValueBox, VueEchart},
        mixins: [data3Processor,smoothLine],
        computed: {
            ecConfig(){
                if (this.ecSummary&&this.ecConfig2){
                    return this.ecConfig2
                } else if (this.ecMonthly&&this.ecConfig3){
                    return this.ecConfig3
                } else {
                    return this.ecConfig1
                }
            },
            savingPercentage () {
                if(this.totalSavingSum===0){
                    return 0;
                }
                return 100*this.totalSavingSum/(this.totalSavingSum+this.totalPowerSum);
            },
            layout(){return{
                title:this.title,
                hovermode: 'closest',
                xaxis: {
                    title:"Cooling Load",
                },
                yaxis: {
                    title: 'COP',
                },
                margin:{
                    l: 70,
                    r: 70,
                    t: 30,
                    pad: 1
                },
                hoverlabel: {
                    namelength: -1
                },
                showlegend:true,
                legend: {
                    orientation: 'h',
                    y:-0.2,
                },
            }},
        },
        name: 'FlexibleCopSavingsWidget',
        watch: {
            dateRange () {
                this.refresh()
            },
            parameters:{
                handler() {
                    this.refresh()
                },
                deep: true,
                immediate: true,
            },
        },
        data: function () {
            return {
                loading: true,
                timeout:null,
                data:null,
                totalSavingSum:0,
                totalPowerSum:0,
                monthlyData:null,
                preCOP:0,
                postCOP:0,
                COPImpr:0,
                ecConfig1:null,
                ecConfig2:null,
                ecSummary:false,
                ecConfig3:null,
                reloadInc:0,
                ecMonthly:false,
                loessData:null,
            }
        },
        mounted(){
            this.refresh()
        },
        methods: {
            exportMonthly(){
                exportCSV(this.monthlyData)
            },
            debounce(callback, wait) {
                clearTimeout(this.timeout);
                this.timeout= setTimeout(() => callback(), wait);
            },
            refresh(){
                this.debounce(this.getData,500);
            },
            copyToCP() {
                let me = this
                this.$copyText(JSON.stringify(this.loessData)).then(function (e) {
                    me.$store.dispatch('callSnackbar', {text: me.$options.filters.translate('Data copied to clipboard')})
                }, function (e) {
                    console.log(e)
                })
            },
            getData() {
                let me = this
                me.loading = true
                this.ecConfig2=null
                this.ecConfig3=null
                this.reloadInc=this.reloadInc+1
                let currentInc=this.reloadInc
                let dateRange=this.dateRange ? [this.dateRange.start,this.dateRange.end.length<12 ? this.dateRange.end+" 23:59:59": this.dateRange.end] : null;
                if (this.startDate&&this.endDate){
                    dateRange=[moment(this.startDate).format('YYYY-MM-DD'),moment(this.endDate).format('YYYY-MM-DD')+" 23:59:59"]
                } else if (this.startDate){
                    let maxDate=this.$store.state.pointsListStore.pointsList.data_max_date;
                    let endDate=moment()
                    if(maxDate){
                        endDate=moment(maxDate)
                    }
                    dateRange=[moment(this.startDate).format('YYYY-MM-DD'),moment(endDate).format('YYYY-MM-DD')+" 23:59:59"]
                }
                let payloadArray=JSON.parse(JSON.stringify(this.data3query['data-payload']))
                payloadArray=payloadArray.filter(x=>x.filters&&(x.filters.sensor_name||x.filters.equipment_name))
                for (let payload of payloadArray){
                    payload.parameters=this.parameters
                    this.processDateRange(payload, {start: dateRange[0], end: dateRange[1]})
                    if(!payload.filters.facility_name&&this.$store.state.pointsListStore.pointsList.facility_name){
                        payload.filters.facility_name=this.$store.state.pointsListStore.pointsList.facility_name
                    }
                    if(payload.onOnly){
                        if(!payload.pipeline){
                            payload.pipeline=[]
                        }
                        payload.pipeline.unshift(
                            {
                                "type": "filter",
                                "filter_op": "eq",
                                "filter_by": "* - on",
                                "filter_value": 1,
                            }
                        )
                    }
                }
                let promises=payloadArray.map(payload=>callAPI('data3/',payload))
                Promise.all(promises).then(function(results) {
                    if (currentInc!==me.reloadInc){
                        return
                    }
                    let Timestamp=null;
                    let Power=null;
                    let Cooling_Load=null;
                    let Switch=null;
                    for (let result of results){
                        if(!Timestamp&&result.data.timestamp){
                            Timestamp=result.data.timestamp
                        }
                        if(result.data[me.powerSensor]){
                            Power=result.data[me.powerSensor]
                        }
                        if(result.data[me.coolingLoadSensor]){
                            Cooling_Load=result.data[me.coolingLoadSensor]
                        }
                        if(result.data[me.switchSensor]){
                            Switch=result.data[me.switchSensor]
                        }
                    }
                    let prePower = [];
                    let postPower = [];
                    let preLabels = [];
                    let postLabels = [];
                    let preCooling_Load=[];
                    let postCooling_Load=[];
                    let preCOP=[];
                    let postCOP=[];
                    let ecPreData=[]
                    let ecPostData=[]
                    let ecInterpData=[]
                    let cutOff=me.cutOff ? moment(me.cutOff).format('YYYY-MM-DD HH:mm:ss') : null
                    for (let index in Timestamp){
                        if(!Power[index]||!Cooling_Load[index]||(me.useSwitch&&Switch[index]===null)){
                            continue;
                        }
                        if((!me.cutOff&&me.useSwitch&&Switch[index]>0.5)||(me.cutOff&&Timestamp[index]>=cutOff&&(!me.useSwitch||Switch[index]>0.5))){
                            postPower.push(Power[index])
                            postCooling_Load.push(Cooling_Load[index])
                            postCOP.push(Cooling_Load[index]/Power[index])
                            postLabels.push(Timestamp[index])
                            ecPostData.push({name:Timestamp[index],value:[Cooling_Load[index],Cooling_Load[index]/Power[index]]})
                        } else {
                            prePower.push(Power[index])
                            preCooling_Load.push(Cooling_Load[index])
                            preCOP.push(Cooling_Load[index]/Power[index])
                            preLabels.push(Timestamp[index])
                            ecPreData.push({name:Timestamp[index],value:[Cooling_Load[index],Cooling_Load[index]/Power[index]]})
                        }
                    }
                    let getY=null
                    if(me.interpolation==="custom"&&me.customInterpolation){
                        getY=eval(me.customInterpolation)
                    } else {
                        let trendBeforeCurb=findLineByLeastSquares(preCooling_Load,preCOP)
                        getY=function(x){
                            return ((x*trendBeforeCurb[0])+trendBeforeCurb[1])
                        }
                    }
                    let preInterpolatedCOP=[]
                    let preInterpolatedCooling_Load=[]
                    let minCl=Math.min(...preCooling_Load,...postCooling_Load)
                    let maxCl=Math.max(...preCooling_Load,...postCooling_Load)
                    for (let i=minCl; i<=maxCl; i=i+10){
                        preInterpolatedCOP.push(getY(i))
                        preInterpolatedCooling_Load.push(i)
                        ecInterpData.push([i,getY(i)])
                    }
                    me.preCOP=preCooling_Load.reduce((a,b)=>a+b)/prePower.reduce((a,b)=>a+b)
                    let data = [
                        {
                            x: me.resamplingFactor ? preCooling_Load.filter((element, index) => index % me.resamplingFactor === 0) : preCooling_Load,
                            y:  me.resamplingFactor ? preCOP.filter((element, index) => index % me.resamplingFactor === 0) : preCOP,
                            type: 'scattergl',
                            mode: 'markers',
                            name: "Before optimisation",
                            hovertext: me.resamplingFactor ? preLabels.filter((element, index) => index % me.resamplingFactor === 0) : preLabels,
                            marker: {
                                color: 'rgb(31, 119, 180)',
                            }
                        },
                        {
                            x: preInterpolatedCooling_Load,
                            y: preInterpolatedCOP,
                            type: 'scattergl',
                            name:"Before optimisation trend",
                            mode: 'lines',
                            line: {
                                color: 'rgb(31, 119, 180)',
                                width: 2,
                                dash:'dot'
                            }
                        },
                    ]
                    let ecConfig1={
                        title : {
                            text:me.title,
                            left:'center'
                        },
                        tooltip: {
                            position: 'top',
                            formatter: function (params) {
                                return (
                                    params.seriesName +
                                    ' <br/>' +
                                    params.name +
                                    ' <br/>' +
                                    params.value[0].toLocaleString() +
                                    'kW ' +
                                    params.value[1].toLocaleString()
                                );
                            },
                        },
                        xAxis: {
                            name:"Cooling Load",
                            nameLocation: 'middle',
                            nameGap: 25
                        },
                        yAxis: {
                            scale: true,
                            name:'COP',
                            nameLocation: 'middle',
                            nameGap: 50
                        },
                        legend: {
                            bottom: 10,
                            left: 'center',
                        },
                        series: [
                            {
                                type: 'scatter',
                                symbolSize: 6,
                                id: 'bms',
                                name:'Before optimisation',
                                dataGroupId: 'bms',
                                universalTransition: {
                                    enabled: true,
                                    delay: function (idx, count) {
                                        return Math.random() * 400;
                                    }
                                },
                                data: me.resamplingFactor ? ecPreData.filter((element, index) => index % me.resamplingFactor === 0) : ecPreData,
                                itemStyle: {
                                    color: 'rgb(31, 119, 180)'
                                }
                            },
                            {
                                type: 'line',
                                showSymbol: false,
                                name:'Before optimisation trend',
                                data: ecInterpData,
                                lineStyle: {
                                    type : 'dashed',
                                    color: 'rgb(31, 119, 180)'
                                },
                                itemStyle: {
                                    color: 'rgb(31, 119, 180)'
                                }
                            },

                        ]
                    }
                    let ecConfig2={
                        xAxis: {
                            type: 'category',
                            data: ['Before optimisation']
                        },
                        yAxis: {},
                        title : {
                            text:'COP',
                            left:'center'
                        },
                        series: [
                            {
                                type: 'bar',
                                id: 'total',
                                data: [
                                    {
                                        value: me.preCOP,
                                        groupId: 'bms',
                                        itemStyle: {
                                            color: 'rgb(31, 119, 180)'
                                        }
                                    },
                                ],
                                label: {
                                    show: true,
                                    position: 'top',
                                    formatter: function(d) {
                                        return d.value.toLocaleString();
                                    }
                                },
                                universalTransition: {
                                    enabled: true,
                                    seriesKey: ['bms', 'opti'],
                                    delay: function (idx, count) {
                                        return Math.random() * 400;
                                    }
                                }
                            }
                        ]
                    }
                    if(postCOP.length>0){
                        let totalPowerSum=0
                        let totalCooling_LoadSum=0
                        let totalSavingSum=0
                        let monthlyDataAgg={}
                        for (let k in postCooling_Load){
                            totalPowerSum+=postPower[k];
                            totalCooling_LoadSum+=postCooling_Load[k];
                            totalSavingSum+=(postCooling_Load[k]/getY(postCooling_Load[k]))-postPower[k];
                            let formatedMonth=moment(postLabels[k]).format("MMM YY")
                            if (!monthlyDataAgg[formatedMonth]){
                                monthlyDataAgg[formatedMonth]={
                                    time:formatedMonth,
                                    saving:0,
                                }
                            }
                            let increm=(postCooling_Load[k]/getY(postCooling_Load[k]))-postPower[k]
                            if(!me.aggFrequency){
                                increm=increm/me.$store.state.pointsListStore.pointsList.sampling_freq
                            }
                            monthlyDataAgg[formatedMonth].saving=monthlyDataAgg[formatedMonth].saving+increm;
                        }
                        let monthlyData=Object.values(monthlyDataAgg)
                        me.monthlyData=monthlyData
                        me.totalPowerSum=totalPowerSum;
                        me.totalSavingSum=totalSavingSum;
                        me.postCOP=totalCooling_LoadSum/totalPowerSum
                        me.COPImpr=-((me.preCOP-me.postCOP)/me.preCOP)*100
                        if(!me.aggFrequency){
                            me.totalPowerSum=totalPowerSum/me.$store.state.pointsListStore.pointsList.sampling_freq;
                            me.totalSavingSum=totalSavingSum/me.$store.state.pointsListStore.pointsList.sampling_freq;
                        }
                        data.push({
                            x: me.resamplingFactor ? postCooling_Load.filter((element, index) => index % me.resamplingFactor === 0) : postCooling_Load,
                            y: me.resamplingFactor ? postCOP.filter((element, index) => index % me.resamplingFactor === 0) : postCOP,
                            type: 'scattergl',
                            mode: 'markers',
                            name: "After optimisation",
                            hovertext: me.resamplingFactor ? postLabels.filter((element, index) => index % me.resamplingFactor === 0) : postLabels,
                            marker: {
                                color: 'rgb(255, 127, 14)',
                            }
                        })
                        ecConfig2.series[0].data.push({
                            value: me.postCOP,
                            groupId: 'opti',
                            itemStyle: {
                                color: 'rgb(255, 127, 14)'
                            }
                        })
                        ecConfig2.series[0].universalTransition.seriesKey.push('opti')
                        ecConfig2.xAxis.data.push('After Optimization')
                        ecConfig1.series.push({
                            type: 'scatter',
                            symbolSize: 6,
                            id: 'opti',
                            name:'After Optimization',
                            dataGroupId: 'opti',
                            universalTransition: {
                                enabled: true,
                                delay: function (idx, count) {
                                    return Math.random() * 400;
                                }
                            },
                            data: me.resamplingFactor ? ecPostData.filter((element, index) => index % me.resamplingFactor === 0) : ecPostData,
                            itemStyle: {
                                color: 'rgb(255, 127, 14)'
                            }
                        })
                        let getPostY=null
                        let hasPostInterpolation=false
                        let interpolationIsLoess=false
                        let interpolationIsProvided=false
                        if(me.postInterpolation==="custom"&&me.customPostInterpolation){
                            getPostY=eval(me.customPostInterpolation)
                            hasPostInterpolation=true
                        } else if (me.postInterpolation==="linear"){
                            let trendAfterCurb=findLineByLeastSquares(postCooling_Load,postCOP)
                            getPostY=function(x){
                                return ((x*trendAfterCurb[0])+trendAfterCurb[1])
                            }
                            hasPostInterpolation=true
                        } else if (me.postInterpolation==="loess"){
                            hasPostInterpolation=true
                            interpolationIsLoess=true
                        }   else if (me.postInterpolation==="manual"&&me.postInterpolationPoints){
                            hasPostInterpolation=true
                            interpolationIsProvided=true
                        }
                        if (hasPostInterpolation){
                            let ecPostInterpData=[]
                            let postInterpCop=[]
                            let postInterpolatedCooling_Load=[]
                            if (interpolationIsProvided){
                                let decoded = JSON.parse(me.postInterpolationPoints)
                                for (let k in decoded){
                                    ecPostInterpData.push([decoded[k][0],decoded[k][1]])
                                    postInterpCop.push(decoded[k][1])
                                    postInterpolatedCooling_Load.push(decoded[k][0])
                                }
                            } else if (interpolationIsLoess){
                                let smoothOptions = {
                                    span: me.span,
                                    band: me.band,
                                    degree: me.degree
                                }
                                let smooth = me.smoothLineLoess(postCooling_Load, postCOP, 50, smoothOptions)
                                for (let k in smooth.data['x']){
                                    ecPostInterpData.push([smooth.data['x'][k],smooth.fitted['fitted'][k]])
                                    postInterpCop.push(smooth.fitted['fitted'][k])
                                    postInterpolatedCooling_Load.push(smooth.data['x'][k])
                                }
                                me.loessData=ecPostInterpData
                            } else {
                                let minCl=Math.min(...preCooling_Load,...postCooling_Load)
                                let maxCl=Math.max(...preCooling_Load,...postCooling_Load)
                                for (let k=minCl; k<=maxCl; k=k+10){
                                    ecPostInterpData.push([k,getPostY(k)])
                                    postInterpCop.push(getPostY(k))
                                    postInterpolatedCooling_Load.push(k)
                                }
                            }
                            ecConfig1.series.push({
                                type: 'line',
                                showSymbol: false,
                                name:'After optimisation trend',
                                data: ecPostInterpData,
                                lineStyle: {
                                    type : 'dashed',
                                    color: 'rgb(255, 127, 14)'
                                },
                                itemStyle: {
                                    color: 'rgb(255, 127, 14)'
                                }
                            })
                            data.push({
                                x: postInterpolatedCooling_Load,
                                y: postInterpCop,
                                type: 'scattergl',
                                name:"After optimisation trend",
                                mode: 'lines',
                                line: {
                                    color: 'rgb(255, 127, 14)',
                                    width: 2,
                                    dash:'dot'
                                }
                            },)
                        }
                        me.ecConfig3={
                            title : {
                                text:me.title,
                                left:'center'
                            },
                            xAxis: {
                                type: 'category',
                                data: monthlyData.map(x=>x.time),
                            },
                            yAxis: {
                                scale: true,
                                name:'Energy Savings (kWh)',
                                nameLocation: 'middle',
                                nameGap: 50
                            },
                            legend: false,
                            series: [
                                {
                                    type: 'bar',
                                    id: 'opti',
                                    name:'Savings',
                                    dataGroupId: 'opti',
                                    universalTransition: {
                                        enabled: true,
                                        seriesKey: ['opti'],
                                        delay: function (idx, count) {
                                            return Math.random() * 400;
                                        }
                                    },
                                    label: {
                                        show: true,
                                        position: 'top',
                                        formatter: function(d) {
                                            return d.value.toLocaleString() + " kWh";
                                        }
                                    },
                                    data: me.showNegativeMonthly ? monthlyData.map(x=>x.saving) : monthlyData.map(x=>Math.max(x.saving,0)),
                                    itemStyle: {
                                        color: 'rgb(255, 127, 14)'
                                    }
                                },
                            ]
                        }
                    }
                    me.data=data
                    me.ecConfig1=ecConfig1
                    me.ecConfig2=ecConfig2
                    me.loading=false
                })
            }
        },
    }

</script>

<style scoped>

</style>
